import { useEffect, useState } from "react";

const useZoomLevel = () => {
    const [zoomLevel, setZoomLevel] = useState(100); // Default zoom level is 100%

    const updateZoomLevel = () => {
        const level = Math.round((window.devicePixelRatio || 1) * 100);
        setZoomLevel(level);
    };

    useEffect(() => {
        // Initial check
        updateZoomLevel();

        // Add event listener to detect zoom changes (via window resize)
        window.addEventListener("resize", updateZoomLevel);

        return () => {
            // Cleanup listener
            window.removeEventListener("resize", updateZoomLevel);
        };
    }, []);

    return zoomLevel;
};

export default useZoomLevel;
